// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { StatusChipProps } from '@/components/status-chip';
import { z } from 'zod';

const INVOICE_STATUS_VALUES = [
  'DRAFT',
  'OPEN',
  'PARTIALLY_PAID',
  'PAID',
  'VOID',
] as const;

export type InvoiceStatus = (typeof INVOICE_STATUS_VALUES)[number];

const INVOICE_STATUS_FILTER_VALUES = ['all', ...INVOICE_STATUS_VALUES] as const;

export type InvoiceStatusFilter = (typeof INVOICE_STATUS_FILTER_VALUES)[number];

export const invoiceStatusSchema = z.enum(INVOICE_STATUS_VALUES);
export const invoiceStatusFilterSchema = z.enum(INVOICE_STATUS_FILTER_VALUES);

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  DRAFT: 'Draft',
  OPEN: 'Open',
  PARTIALLY_PAID: 'Partially paid',
  PAID: 'Paid',
  VOID: 'Void',
};

export function getInvoiceStatusChipProps(
  status: InvoiceStatus
): StatusChipProps {
  switch (status) {
    case 'DRAFT':
      return {
        label: INVOICE_STATUS_LABELS[status],
        color: 'default',
        variant: 'outlined',
      };
    case 'OPEN':
      return {
        label: INVOICE_STATUS_LABELS[status],
        color: 'info',
        variant: 'filled',
      };
    case 'PARTIALLY_PAID':
      return {
        label: INVOICE_STATUS_LABELS[status],
        color: 'warning',
        variant: 'filled',
      };
    case 'PAID':
      return {
        label: INVOICE_STATUS_LABELS[status],
        color: 'success',
        variant: 'filled',
      };
    case 'VOID':
      return {
        label: INVOICE_STATUS_LABELS[status],
        color: 'error',
        variant: 'outlined',
      };
  }
}
